import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { LanguageProvider } from "./hooks/LanguageProvider";
import { AuthProvider } from "./hooks/useAuth";
import { BreadcrumbProvider } from "./hooks/useBreadcrumb";
import { ChatPusherProvider } from "./hooks/useChatPusher";

const root = createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <AuthProvider>
      <ChatPusherProvider>
        <LanguageProvider>
          <BreadcrumbProvider>
            <App />
          </BreadcrumbProvider>
        </LanguageProvider>
      </ChatPusherProvider>
    </AuthProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
